import React from "react";

function BlogItemCard({ detailsLink, imgSource }) {
  return <div></div>;
}

export default BlogItemCard;
